import React from 'react';
import { Radio } from 'antd';

// 支付相关
import Payment from '@/components/Payment';
import PayModal from '@/components/Payment/payModal';
import { parseYuan2Currency } from '@/utils/number';
import { renderIntlLabel } from '@/utils';
import styles from './SaleType.module.scss';

interface ISaleType {
  name: string;
  certNo: string;
  roomNo: string;
  resvNo: string;
  roomStatus: number | null;

  paymentTypes: 0 | 1;
  payRadioChange: (paymentTypes: 0 | 1) => void;

  actualPay: number;

  payModalRef: any;
  setPayType: () => void;
  selectPayType: (type: any) => void;
  payResultCallback: (payResult: Object) => void;
  onConfirmOk: () => void;
}

// 购物车
function SaleType($$: ISaleType) {
  return (
    <div className={styles.SaleType}>
      <p className={styles.title}>{renderIntlLabel('goods_label_sale_type')}</p>
      <div className={styles.row}>
        <div className={styles.label}>{renderIntlLabel('goods_label_credited_room')}:</div>
        <div className={styles.infos}>
          <div>
            {$$.roomNo || '--'}{' '}
            {$$.roomStatus === 4
              ? `（${renderIntlLabel('order_roomorder_tab_name_checkedout')}）`
              : ''}
          </div>
          <div className={styles.name}>
            {$$.name || '--'} {$$.certNo || '--'}
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.label}>
          {renderIntlLabel('goods_label_should_receivable_money')}:
        </div>
        <div className={styles.infos}>{parseYuan2Currency($$.actualPay || 0)}</div>
      </div>
      <div className={styles.row}>
        <div className={styles.label}>{renderIntlLabel('goods_label_sale_method')}:</div>
        <div className={styles.infos}>
          <Radio.Group
            name="paymentTypes"
            onChange={(e) => $$.payRadioChange(e.target.value)}
            value={$$.paymentTypes}
          >
            <Radio value={0}>{renderIntlLabel('goods_option_label_enter_account_and_pay')}</Radio>
            <Radio value={1}>
              {renderIntlLabel('goods_option_label_first_account_later_settlement')}
            </Radio>
          </Radio.Group>
        </div>
      </div>
      {/* 收款方式 */}
      {$$.paymentTypes === 0 && (
        <div className={styles.row}>
          <div className={styles.infos}>
            <Payment
              isInitPayTypes
              selectPayType={(type) => $$.selectPayType(type)}
              resvNo={$$.resvNo}
            />
          </div>
        </div>
      )}
      <PayModal
        ref={$$.payModalRef}
        payResultCallback={(payResult) => $$.payResultCallback(payResult)}
        onConfirmOk={$$.onConfirmOk}
      />
    </div>
  );
}

export default SaleType;
